import { POST_LOGIN_REDIRECT_KEY } from "../config/MsalConfig"

const toAppRoute = (href) => {
  if (!href) return null
  try {
    const url = new URL(href, window.location.origin)
    if (url.origin !== window.location.origin) return null
    const hashRoute = url.hash.startsWith("#/") ? url.hash.slice(1) : null
    const route = hashRoute || url.pathname + url.search
    return route && route !== "/" ? route : null
  } catch {
    return null
  }
}

export const getCurrentAppRoute = () => toAppRoute(window.location.href)

export const savePostLoginRedirect = (href = window.location.href) => {
  if (toAppRoute(href)) sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, href)
}

export const peekPostLoginRedirect = () =>
  toAppRoute(sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY))

export const clearPostLoginRedirect = () => {
  sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY)
}
